"use strict";

exports.__esModule = true;
exports.grid = void 0;

var _core = require("../core");

const config = {
  gridArea: true,
  gridAutoColumns: true,
  gridAutoFlow: true,
  gridAutoRows: true,
  gridColumn: true,
  gridColumnGap: {
    property: 'gridColumnGap',
    scale: 'space'
  },
  gridGap: {
    property: 'gridGap',
    scale: 'space'
  },
  gridRow: true,
  gridRowGap: {
    property: 'gridRowGap',
    scale: 'space'
  },
  gridTemplateAreas: true,
  gridTemplateColumns: true,
  gridTemplateRows: true,
  placeItems: true
};
config.gap = config.gridGap;
const grid = (0, _core.system)(config);
exports.grid = grid;